// extracted by mini-css-extract-plugin
export default {"Container":"Dropdown_Container__AzQMR"};